<template>
  <div>
    <div class="py-2 font-bold">
      {{ t("share") }}
    </div>
    <hr />
    <SchemaShareChannel
      v-for="channel of ownedChannels"
      :key="channel.id"
      v-model="selectedChannels[channel.id]"
      :title="channel.name"
    />
    <hr class="py-2" />
    <div class="flex w-full justify-end gap-3">
      <LexmeaButton
        class="w-48"
        :disabled="shareSchemaMutation.isPending.value"
        design="link"
        @click="emit('close')"
        >{{ $t("cancel") }}
      </LexmeaButton>
      <LexmeaButton
        class="w-48"
        :loading="shareSchemaMutation.isPending.value"
        @click="handleApplyChanges()"
        >{{ $t("apply_changes") }}
      </LexmeaButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ISchema } from "~/models/IUserEntry";
import type { IOwnedChannel } from "~/models/teamMode/IChannel";

const emit = defineEmits<{
  close: [];
}>();

const props = defineProps<{
  schema: ISchema;
}>();

const { t } = useI18n({ useScope: "local" });
const { data: ownedChannels } = useOwnedChannelsQuery();
const selectedChannels = ref<boolean[]>([]);
const { shareSchemaMutation } = teamModeMutations();

async function handleApplyChanges() {
  const channelIds = selectedChannels.value
    .map((value, index) => ({ value, index }))
    .filter((item) => item.value)
    .map((item) => item.index);

  shareSchemaMutation.mutate(
    {
      schemaId: props.schema.id,
      channelIds,
    },
    {
      onSuccess: () => {
        emit("close");
      },
    }
  );
}

function initSelectedChannels(channels: IOwnedChannel[]) {
  for (const channel of channels) {
    if (
      channel.schemas.filter((schema) => schema.id === props.schema.id).length >
      0
    ) {
      selectedChannels.value[channel.id] = true;
    }
  }
}

watchImmediate(ownedChannels, () => {
  if (ownedChannels?.value?.length) {
    initSelectedChannels(ownedChannels.value);
  }
});
</script>

<i18n>
{
  "de": {
    "share": "In Kanal teilen"
  },
  "en": {
    "share": "Share in channel"
  }
}
</i18n>
